export class CfsPutDto {
  id?: number;
  cfsCode: string;
}
